import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, TextField } from "@mui/material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import { useEffect, useState } from "react";

function BankAdmin() {
    const [bank, setBank] = useState();
    const [load, setLoad] = useState(true);
    const [isShow, setShow] = useState(false);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [bankItem, setBankItem] = useState();
    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getbank`, {}).then((res) => {
                setBank(res.data.data);
                setLoad(false);
            });
        }
    }, [load]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            fullname: e.target.fullname.value,
            stk: e.target.stk.value,
            name_bank: e.target.name_bank.value,
            title: e.target.title.value,
            qr: e.target.qr.value
        };

        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/newbank`, formData)
            .then((res) => {
                setLoad(true);
                swal(t('success'), "", "success").then((value) => {
                    window.location.reload();
                });
            })
            .catch((res) => setLoad(true));
    };
    const handleSubmitBank = (e) => {
        e.preventDefault();
        const formData = {
            id: bankItem._id,
            fullname: e.target.fullname.value,
            stk: e.target.stk.value,
            name_bank: e.target.name_bank.value,
            title: e.target.title.value,
            qr: e.target.qr.value
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/editlistbank`, formData).then((res) => {
            swal(t('success'), "", "success");
            setLoad(true);
            setShow(false);
        });
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {profile?.permission?.full == 1 ? (
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 8
                            }}>
                            <Container maxWidth={false}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>{t("setting_bank")}</div>
                                <div style={{ marginTop: "20px" }}>
                                    <form onSubmit={handleSubmit} className="form-admin">
                                        <div>
                                            <div>
                                                <label>{t("bank_account")}</label>
                                                <input required name="fullname" id="fullname" />
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <label>{t("bank_name")}</label>
                                                <input name="name_bank" id="name_bank" required />
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <label>{t("bank_number")}</label>
                                                <input type="text" name="stk" id="stk" required />
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <label>{t("content_bank")}</label>
                                                <input type="text" name="title" id="title" />
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <label>QR URL</label>
                                                <input type="text" name="qr" id="qr" />
                                            </div>
                                        </div>
                                        <div>
                                            <button className="btn_setting">{t("add_new")}</button>
                                        </div>
                                    </form>
                                </div>
                                <div className="form_set">
                                    <Box>
                                        <Table sx={{ width: "100%" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ padding: "10px" }}>{t("bank_name")}</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>{t("bank_number")}</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>{t("bank_account")}</TableCell>
                                                    <TableCell sx={{ padding: "10px" }}>{t("content_bank")}</TableCell>
                                                    <TableCell style={{ textAlign: "right" }}>{t("more")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {bank != null ? (
                                                    <>
                                                        {bank.map((item) => (
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.name_bank}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}> {item.stk}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.fullname}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item.title}</TableCell>
                                                                <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                    <Button
                                                                        onClick={() => {
                                                                            axios
                                                                                .post(`${process.env.REACT_APP_API_URL}/auth/editlistbank`, {
                                                                                    id: item._id,
                                                                                    isShow: !item.isShow
                                                                                })
                                                                                .then((res) => setLoad(true));
                                                                        }}>
                                                                        {item.isShow === true ? t("hide") : t("show")}
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            axios
                                                                                .get(`${process.env.REACT_APP_API_URL}/auth/bankall/${item._id}`, {})
                                                                                .then((res) => {
                                                                                    setBankItem(res.data.data);
                                                                                    setShow(true);
                                                                                })
                                                                                .catch((res) => {
                                                                                    swal(t("fail"), "", "error");
                                                                                    setLoad(false);
                                                                                });
                                                                        }}>
                                                                        {(t('edit'))}
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div style={{ fontSize: "16px", textAlign: "center", padding: "10px" }}>{t("waiting")}</div>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>
                                {isShow === true ? (
                                    <>
                                        <div className="modal">
                                            <div className="modaloverlay">
                                                <i className="ti-close closelogin"></i>
                                            </div>
                                            <div style={{ backgroundColor: "white" }} className="modalbody">
                                                {bankItem != null ? (
                                                    <>
                                                        <form onSubmit={handleSubmitBank}>
                                                            <div className="modalinner">
                                                                <div className="modalheader"> {t("edit")} </div>
                                                                <div className="modalform">
                                                                    <div className="modalformgroup" style={{ padding: "9px" }}>
                                                                        <TextField
                                                                            name="name_bank"
                                                                            defaultValue={bankItem.name_bank}
                                                                            sx={{ width: "100%" }}
                                                                            type="text"
                                                                            required
                                                                            placeholder={t("bank_name")}
                                                                        />
                                                                    </div>
                                                                    <div style={{ padding: "9px" }} className="modalformgroup">
                                                                        <TextField
                                                                            name="stk"
                                                                            defaultValue={bankItem.stk}
                                                                            sx={{ width: "100%" }}
                                                                            type="text"
                                                                            required
                                                                            placeholder={t("bank_number")}
                                                                        />
                                                                    </div>
                                                                    <div style={{ padding: "9px" }} className="modalformgroup">
                                                                        <TextField
                                                                            name="fullname"
                                                                            defaultValue={bankItem.fullname}
                                                                            sx={{ width: "100%" }}
                                                                            type="text"
                                                                            required
                                                                            placeholder={t("bank_account")}
                                                                        />
                                                                    </div>
                                                                    <div style={{ padding: "9px" }} className="modalformgroup">
                                                                        <TextField
                                                                            name="title"
                                                                            defaultValue={bankItem.title}
                                                                            sx={{ width: "100%" }}
                                                                            type="text"
                                                                            placeholder={t("content")}
                                                                        />
                                                                    </div>
                                                                    <div style={{ padding: "9px" }} className="modalformgroup">
                                                                        <TextField name="qr" defaultValue={bankItem.qr} sx={{ width: "100%" }} type="text" placeholder="QR URL" />
                                                                    </div>
                                                                </div>
                                                                <div style={{ padding: "9px" }} className="modalformgroup"></div>
                                                                <div className="item_btn_form">
                                                                    <div className="modalformcontrols">
                                                                        <Button type="submit">{t("submit")}</Button>
                                                                    </div>
                                                                    <div className="modalformcontrols">
                                                                        <Button onClick={() => setShow(false)}>{t("close")}</Button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </>
                                                ) : (
                                                    <div>{t("waiting")}</div>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </Container>
                        </Box>
                    ) : (
                        <div>{t("not_permission")}</div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default BankAdmin;
